var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#F07878",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2470 4740 c-214 -33 -404 -199 -472 -410 -29 -91 -29 -249 0 -340 59 -184 212 -335 397 -392 95 -29 243 -29 335 1 182 58 333 209 392 391 29 91 29 249 0 340 -89 276 -371 454 -652 410z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 3140 c-214 -33 -404 -199 -472 -410 -29 -91 -29 -249 0 -340 59 -184 212 -335 397 -392 95 -29 243 -29 335 1 182 58 333 209 392 391 29 91 29 249 0 340 -89 276 -371 454 -652 410z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1540 c-214 -33 -404 -199 -472 -410 -29 -91 -29 -249 0 -340 59 -184 212 -335 397 -392 95 -29 243 -29 335 1 182 58 333 209 392 391 29 91 29 249 0 340 -89 276 -371 454 -652 410z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.8e20be6bb45f4157ba5cb5bd5b58c134.svg";
export { ForwardRef as ReactComponent };